import VAMap from './VAMap.vue'
import VAMapMarker from './VAMapMarker.vue'
import VAMapMassMarks from './VAMapMassMarks.vue'
import VAMapPolygon from './VAMapPolygon.vue'
import VAMapPlaceSearchInput from './VAMapPlaceSearchInput.vue'

export default [
	VAMap,
	VAMapMarker,
	VAMapMassMarks,
	VAMapPolygon,
	VAMapPlaceSearchInput
]
